/*!

=========================================================
* Black Dashboard React v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React, { useState, useEffect } from "react";

// reactstrap components
import { Container, Nav, NavItem, NavLink } from "reactstrap";

function Footer() {
  const [buildVersion, setBuildVersion] = useState('Loading...');
  const [isDev, setIsDev] = useState(false);
  
  useEffect(() => {
    // Detect environment using centralized detection from config_loader.js
    const env = window.getZiroEnvironment ? window.getZiroEnvironment() : 'prod';
    const dev = env === 'dev';
    setIsDev(dev);
    
    // Add environment class to body for CSS targeting
    if (dev) {
      document.body.classList.add('env-dev');
      document.documentElement.classList.add('env-dev');
    } else {
      document.body.classList.remove('env-dev');
      document.documentElement.classList.remove('env-dev');
    }
    
    // Function to check for build info and update state
    const updateBuildVersion = () => {
      if (window.ZIRO_BUILD_INFO && window.ZIRO_BUILD_INFO.versionString) {
        setBuildVersion(window.ZIRO_BUILD_INFO.versionString);
      } else {
        // Retry if chat.js hasn't loaded yet
        setTimeout(updateBuildVersion, 100);
      }
    };
    
    // Try immediately
    updateBuildVersion();
    
    // Also listen for a custom event that chat.js can dispatch when it loads
    const handleBuildInfoReady = () => {
      if (window.ZIRO_BUILD_INFO && window.ZIRO_BUILD_INFO.versionString) {
        setBuildVersion(window.ZIRO_BUILD_INFO.versionString);
      }
    };
    
    window.addEventListener('ziro:build-info-ready', handleBuildInfoReady);
    
    // Cleanup
    return () => {
      window.removeEventListener('ziro:build-info-ready', handleBuildInfoReady);
    };
  }, []);
  
  return (
    <footer className="footer">
      <Container fluid>
        <Nav>
        </Nav>
        <div className="copyright">
          Ziro AI © {new Date().getFullYear()} ZeroUI, Inc.{' '}
          <span className="build-info">{buildVersion}</span>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
